export default __webpack_public_path__ + "static/media/logo-wholistic.49119c46.jpg";